import type { ElawContract } from '@/types/approval';

/** 표기 포맷(금액·기간·링크)은 @components/ContractInfo/format 공용. 여기는 선택 목록 전용 */

/** 선택 목록 라벨 — 같은 계약명이 흔해 상대방을 덧붙여 구분. 계약명 없으면 fallback */
export const contractOptionLabel = (
  contract: ElawContract,
  fallbackName: string,
): string => {
  const name = contract.contractName?.trim() || fallbackName;
  const opponent = contract.opponentInfo?.trim();
  return opponent ? `${name} · ${opponent}` : name;
};

const normalize = (value?: string | null) => (value ?? '').toLowerCase();

/** 레거시 드롭다운 필터와 같은 4필드 contains */
export const matchesContractQuery = (
  contract: ElawContract,
  query: string,
): boolean => {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [
    contract.contractName,
    contract.opponentInfo,
    contract.creatorInfo,
    contract.startDate,
  ].some((field) => normalize(field).includes(q));
};

/** 여러 응답을 ID 로 합침 — 앞 목록 우선(재조회 응답의 최신 accessLink 유지) */
export const indexContractsById = (
  lists: (ElawContract[] | undefined)[],
): Map<number, ElawContract> => {
  const map = new Map<number, ElawContract>();
  lists.forEach((list) => {
    list?.forEach((contract) => {
      if (!map.has(contract.contractId)) map.set(contract.contractId, contract);
    });
  });
  return map;
};
